import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./usergroup.css";
import { faAngleRight, faChevronLeft, faChevronRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Box } from '@mui/material';
import Select from 'react-select';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Modal } from 'react-bootstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import KbAcessGroup from './KbAcessGroup';
const profileImage = require('../../assets/defaultprofile.svg').default;
function UserGroupEdit() {
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const UserRoles = localStorage.getItem('role');
    const [activeTab, setActiveTab] = useState("member");
    const [errors, setErrors] = useState({});
    const [errorsmessage, setErrorMessage] = useState('');
    const [show, setShow] = useState(false);
    const [memberdata, setMemberData] = useState([]);
    const [permissionsData, setPermissionsData] = useState([]);
    const [rolesUsers, setUsersOptions] = useState([]);
    const [tabsOption, setTabsOptions] = useState([]);
    const [permissionOption, setPermssionOptions] = useState([]);
    const [selectPermission, setSelectPermission] = useState([]);
    const [selectPermissionTypes, setSelectPermissionTypes] = useState([]);
    const [selectUsers, setSelectUser] = useState([]);
    const [rolesTypeUsers, setUsersTypeOptions] = useState([]);
    const [selectUsersTypes, setSelectUserTypes] = useState([]);
    // const [managerOption, setManagerOption] = useState([]);
    const [selectManager, setSelectManager] = useState([]);
    const [submitloader, setSubmitloader] = useState(false);
    const [systemGroup, setSystemGroup] = useState(false);
    const [paginatedata, setPaginateData] = useState({});
    const [selectedRecord, setShowRecord] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginatedata2, setPaginateData2] = useState({});
    const [currentPage2, setCurrentPage2] = useState(1);
    const [selectedRecord2, setShowRecord2] = useState(20);
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingAll, setLoadingAll] = useState(false);
    
    const { id } = useParams(); // Retrieve the group ID from the URL
    const [groupData, setGroupData] = useState({ name: '', permissions: [], group_type: ''});
    const navigate = useNavigate();
    
    const fetchPermissionData = useCallback(async (params = {}) => {
        if(id && activeTab === "permissions"){
            setLoading(true);
        try {
            const defaultParams = {
                page: 1,
                per_page: params?.per_page ?? selectedRecord2,
            };
            const finalParams = { ...defaultParams, ...params };
            const response = await apiService.postRequest(`admin/role/permissions/${id}`, finalParams);
            if(response && response.success){
                setPermissionsData(response.data || []);
                setPaginateData2(response.meta);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching group data:', error);
        }finally {
            setLoading(false);
        }}
    }, [id, activeTab, selectedRecord2]);
    const handlePageChange2 = (newPage) => {
        setCurrentPage2(newPage);
        fetchPermissionData({ page: newPage });
    };
    useEffect(() => {
        fetchPermissionData();
    }, [fetchPermissionData]);
    
    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
        const params ={
            search: searchQuery,
            page : page,
            group_type: groupData.group_type,
            role_id: Number(id)
        }
        if (groupData.group_type === 'external') {
            try {
            const response = await apiService.postRequest(
                `admin/roles-manager-list`, params
            );
            if(response && response.success === true){
            return {
                options: response?.data
                    ?.filter(item => {
                    const type = item.user_type?.toLowerCase().replace(/\s+/g, "_");
                    return type !== "job_seeker";
                    })
                    .map(item => ({
                    value: item.id,
                    label: item.name,
                    type: item.user_type,
                })) || [],
                hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
                additional: {
                page: page + 1,
                },
            };
            }else{
                return {
                    options: [],
                    hasMore: false,
                };
            }} catch (error) {
            console.error('Error loading options:', error);
            return {
                options: [],
                hasMore: false,
            };
            }
        }
    };
    const [additionalOptions, setAdditionalOptions] = useState([]);
    const [cacheKey, setCacheKey] = useState(0);

    const loadOptionsUpend = async (searchQuery, loadedOptions, { page }) => {
        
        if (groupData.group_type !== 'external') {
            try {
                const response = await apiService.postRequest(
                    `admin/roleusers/${id}`
                );
                
                if (response && response.success === true) {
                    const apiOptions =
                        response?.data
                            ?.filter(item => {
                            const type = item.user_type?.toLowerCase().replace(/\s+/g, "_");
                            return type !== "job_seeker";
                            })
                            .map(item => ({
                            value: item.id,
                            label: item.name,
                            type: item.user_type,
                        })) || [];
                    
                    const filteredAdditionalOptions = additionalOptions.filter(option =>
                        option.label.toLowerCase().includes((searchQuery || '').toLowerCase())
                    );
                    
                    // ✅ Combine filtered additional options with API options (only on first page)
                    const combinedOptions = page === 1 
                        ? [...filteredAdditionalOptions, ...apiOptions]
                        : apiOptions;
                    return {
                        options: combinedOptions,
                        hasMore: response?.meta?.current_page < response?.meta?.last_page,
                        additional: {
                            page: page + 1,
                        },
                    };
                } else {
                    return {
                        options: additionalOptions,
                        hasMore: false,
                    };
                }
            } catch (error) {
                console.error('Error loading options:', error);
                return {
                    options: additionalOptions,
                    hasMore: false,
                };
            }
        }
    };
    
    const fetchTabsoption = useCallback(async () => {
        if(activeTab === "permissions"){
        try {
            const response = await apiService.postRequest('/permission/tabList');
            if(response && response.success === true){
                const options = response && response.data
                .map(role => ({
                    value: role,
                    label: role,
                }));
                setTabsOptions(options);
            }
        } catch (error) {
            console.error('Error fetching tabs:', error);
        }}
    }, [activeTab]);
    useEffect(() => {
        fetchTabsoption();
    }, [fetchTabsoption]);

    const handlePermissionType = (selectedOptions) => {
        setSelectPermissionTypes(selectedOptions);
        setSelectPermission([]);
    };


    const fetchPermissionoption = useCallback(async () => {
        if(activeTab === "permissions" && selectPermissionTypes){
        try {
            // const navigate_option = { group_id: Number(id),group_type: groupData.group_type, tabs : (selectPermissionTypes ?? []).map(type => type.value)}
            const navigate_option = { group_id: Number(id),group_type: groupData.group_type, tabs: selectPermissionTypes?.value ? [selectPermissionTypes.value] : []}
            const response = await apiService.postRequest('/permissions/by-tabs', navigate_option);
            if(response && response.success === true){
                const options = response && response.data
                .map(role => ({
                    value: role.id,
                    label: role.display_name,
                }));
                setPermssionOptions(options);
            }else{
                setPermssionOptions([]);
            }
        } catch (error) {
            console.error('Error fetching tabs:', error);
        }
        }
    }, [selectPermissionTypes, id, groupData.group_type, activeTab]);
    useEffect(() => {
        fetchPermissionoption();
    }, [fetchPermissionoption]);

    const handlePermissionChange = (selectedOptions) => {
        setSelectPermission(selectedOptions);
    };



    useEffect(() => {
        if(groupData.group_type === "internal"){
            setSelectUserTypes([]);
            setUsersTypeOptions([
                {value: "sub_admin", label: "Sub Admin"},
            ])
        }else{
            setSelectUserTypes([]);
            setUsersTypeOptions([
                {value: "sub_admin", label: "Sub Admin"},
                {value: "job_seeker", label: "Jobseeker"}
            ])
        }
    },[groupData, groupData.group_type]);

    const fetchGroupData = useCallback(async () => {
        setLoadingAll(true);
        try {
            const response = await apiService.getRequest(`admin/roles/${id}`);
            if(response && response.success){
                setGroupData(response.data);
                setSelectManager(
                    response?.data?.group_manager
                        ? {
                            value: response.data.group_manager.id,
                            label: response.data.group_manager.name,
                        }
                        : []
                    );
                setSystemGroup(response.data.is_system);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching group data:', error);
        }finally{
            setLoadingAll(false);
        }
    }, [id]);
    const fetchMemberData = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const defaultParams = {
                page: 1,
                type: "groups",
                per_page: params?.per_page ?? selectedRecord,
            };
            const finalParams = { ...defaultParams, ...params };
            const response = await apiService.postRequest(`admin/roleusers/${id}`, finalParams);
            if(response && response.success){
                setMemberData(response.data || []);
                setPaginateData(response.meta);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching group data:', error);
        }finally {
            setLoading(false);
        }
    }, [id, selectedRecord]);
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchMemberData({ page: newPage });
    };

    // Handle search query change
    const handleSearch = () => {
        setCurrentPage(1);
        fetchMemberData({ search: searchQuery });
    };
    useEffect(() => {
        fetchMemberData();
    }, [fetchMemberData]);

    const fetchRoles = useCallback(async () => {
        if(id && groupData.group_type && selectUsersTypes){
            try {
                const group_mem = {group_id: Number(id), group_type : groupData.group_type, user_type : (selectUsersTypes ?? []).map(user => user.value)}
                const response = await apiService.postRequest('/admin/role-users-list', group_mem);
                if(response && response.success === true){
                    const options = response && response.data
                    .map(role => ({
                        value: role.id,
                        label: role.name,
                        type: role.user_type,
                    }));
                    setUsersOptions(options);
                }
            } catch (error) {
                console.error('Error fetching roles:', error);
            }
        }
    }, [id, groupData.group_type, selectUsersTypes]);
    useEffect(() => {
        fetchRoles();
    }, [fetchRoles]);
    const handleManagerChange = (selectedOptions) => {
        setSelectManager(selectedOptions);
    };
    const handleUsersTypeChange = (selectedOptions) => {
        setSelectUserTypes(selectedOptions);
        setSelectUser([]);
        setUsersOptions([]);
    };

    const handleUsersChange = (selectedOptions) => {
        const safeOptions = selectedOptions || [];

        setSelectUser(selectedOptions);

        // Always mirror selected options
        const formattedOptions = safeOptions
        .filter(item => {
            const type = item.type?.toLowerCase().replace(/\s+/g, "_");
            return type !== "job_seeker";
        })
        .map(item => ({
            value: item.value,
            label: item.label,
        }));

        setAdditionalOptions(formattedOptions);
        setCacheKey(prev => prev + 1);
    };

    useEffect(() => {
        fetchGroupData();
    }, [fetchGroupData]);

    const validateForm = () => {
        const newErrors = {};

        if (!groupData.name) newErrors.name = "Group Name is required.";
        if (!groupData.group_type) newErrors.group_type = "Group Type is required.";
        
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleUpdate = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        const payload = {
            name: groupData?.name || null,
            group_type: groupData?.group_type || null,
            permissions: (selectPermission ?? []).map(type => type.value),
            sub_admins: (selectUsers ?? []).map(user => user.value),
            group_manager_id: selectManager?.value,
        };
        setSubmitloader(true);
        try {
            const response = await apiService.putRequest(`admin/roles/${id}`, payload);
            if(response && response.success === true){
                fetchMemberData({ search: searchQuery, page: currentPage });
                fetchPermissionData({ page: currentPage2 });
                fetchRoles();
                fetchGroupData();
                setSelectPermission([]);
                setSelectPermissionTypes([]);
                setSelectUser([]);
                setSelectUserTypes([]);
                setErrorMessage("");
                toast(response.message || 'Group Updated Successfully!');
            }else{
                toast(response.message);
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error updating group data:', error);
        } finally {
            setSubmitloader(false); // Stop loader
        }
    };

    
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const handleDelete = async () => {
        try {
            const response = await apiService.deleteRequest(`admin/roles/${id}`);
            if (response && response.success === true) {
                toast(response.message || "Group deleted successfully");
                navigate("/user/group");
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error deleting group:', error);
            toast.error("Failed to delete group");
        }
        handleClose();
    };

    const handleRemove = async (userId) => {
        const removeMemberPayload = {
          group_id: id,
        };
    
        try {
          const response = await apiService.postRequest(`/admin/users/${userId}/remove-group`, removeMemberPayload);
          if (response && response.success === true) {
            toast(response.message || 'Member Removed Successfully!');
            fetchRoles();
            fetchMemberData({ search: searchQuery, page: currentPage });
        } else {
            toast(response.message);
            console.error("Failed to remove user from group");
            if(response && response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
          }
        } catch (error) {
          console.error("Error removing user from group:", error);
        }
    };

    const rows = memberdata && memberdata.map((datas) => ({
        id: datas.id,
        formatId: datas.formatted_id,
        user_type: datas.user_type,
        userName: datas.name,
        userImage: datas.profile || profileImage,
        contactEmail: datas.email,
        isManager: datas.is_group_manager,  
    }));
    const columns = [
        {
            field: 'formatid',
            headerName: 'ID',
            minWidth: 400,
            flex: 1,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {params.row.user_type === "sub_admin" ? 
                        <Link to={`/user/member-edit/${params.row.id}`} target='_blank' className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.formatId}</Link>
                    :
                        <Link to={`/user/jobseeker-details/${params.row.id}`} target='_blank' className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.formatId}</Link>
                    }
                </div>
            ),
            filterable: false,
            sortable: false,
        },
        {
            field: 'userName',
            headerName: 'User',
            minWidth: 400,
            flex: 1,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100 margin_unsetavatar'>
                    <Avatar src={params.row.userImage} alt={params.row.userName} />
                    <span className='ms-3'>{params.row.userName} {params.row.isManager === true && <b className='manager_groupshow'>Manager</b>}</span>
                </div>
            ),
            filterable: false,
            sortable: false,
        },
        {
            field: 'contactEmail',
            headerName: 'Email',
            minWidth: 400,
            flex: 1,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <a className='link_mailmember' href={`mailto:${params.row.contactEmail}`} target="_blank" rel="noopener noreferrer">{params.row.contactEmail}</a>
            )
        },
        ...(
  !["3", "4", "5"].includes(String(id)) &&
  permissionstest?.manage_group_writer === true
    ? [
        {
          field: "action",
          headerName: "Action",
          minWidth: 300,
          flex: 1,
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div className="h-100 d-flex align-items-center">
              {permissionstest?.manage_group_reader === true && (
                <>
                  {params.row.isManager ? (
                    <button
                      type="button"
                      className="disabled_btnapply d-flex justify-content-center align-items-center"
                      style={{ width: "120px", height: "35px" }}
                      disabled
                    >
                      Remove
                    </button>
                  ) : (
                    <button
                      className="save_btnbonly d-flex justify-content-center align-items-center"
                      onClick={() => handleRemove(params.row.id)}
                    >
                      Remove
                    </button>
                  )}
                </>
              )}
            </div>
          ),
        },
      ]
    : []
)
    ];


    const rows2 = permissionsData.map((datas, index) => ({
        index: paginatedata2?.from + index,
        id: datas.id,
        permissionType: datas.tab,
        permissionFor: datas.display_name,
        description: datas.description || "No Description",
    }));
    const columns2 = [
        {
            field: 'index',
            headerName: 'S.No',
            minWidth: 150,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'permissionFor',
            headerName: 'Permission For',
            minWidth: 350,
            flex: 1,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {permissionstest && permissionstest.manage_subadmin_writer === true ? 
                        <Link to={`/user/permissions-details/${params.row.id}`} className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.permissionFor}</Link>:
                        <span style={{color:"#C42B7D"}}>{params.row.permissionFor}</span>
                    }
                </div>
            ),
        },
        {
            field: 'permissionType',
            headerName: 'Permission Type',
            minWidth: 350,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'description',
            headerName: 'Description',
            minWidth: 500,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'action',
            headerName: 'Action',
            minWidth: 200,
            flex: 1,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
            <div className='h-100 d-flex align-items-center'>
                <button
                    className='save_btnbonly d-flex justify-content-center align-items-center'
                    onClick={() => handleRemovePermission(params.row.id)}
                >
                    Remove
                </button>
            </div>
            )
        },
    ];


    const handleRemovePermission = async (permissionId) => {
        const removePermissionPayload = {
          permissions: permissionId,
        };
    
        try {
          const response = await apiService.postRequest(`/admin/roles/permissions/remove/${id}`, removePermissionPayload);
          if (response && response.success === true) {
            toast(response.message || 'Permission Removed Successfully!');
            fetchPermissionData({ page: currentPage2 });
        } else {
            toast(response.message);
            if(response && response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
          }
        } catch (error) {
          console.error("Error removing user from group:", error);
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container group_datatablescrool'>
            <Grid size={{xs:12}} container justifyContent="center" className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>User</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/user/group")}>User</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/user/group")}>Group</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Edit Group</span>
                    </Grid>
                    <Grid size={{xs:12}} container className="editgrouphead my-4">
                        <h2>Edit Group</h2>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container justifyContent="center">
                    {loadingAll === true ?
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> : <>
                        <Grid size={{md:11,xs:12}} container justifyContent="space-between">
                            <Grid size={{md:5,xs:12}} container flexDirection="column" className="input_groupname">
                                <span className='fw-bold fs-6'>Group Name<small className='red_starimpo'>*</small></span>
                                <input type='text' disabled={systemGroup === 1} placeholder='Group Name' value={(groupData && groupData.name) ? groupData.name : ""} 
                                    onChange={(e) => {setGroupData({ ...groupData, name: e.target.value });
                                    setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        name: '',
                                    }));
                                }}/>
                                {errors.name && <p style={{color:"red"}}>{errors.name}</p>}
                            </Grid>
                            <Grid size={{md:5,xs:12}} container flexDirection="column" className="input_groupname">
                                <span className='fw-bold fs-6'>Group Type<small className='red_starimpo'>*</small></span>
                                <select disabled={systemGroup === 1} value={(groupData && groupData.group_type) ? groupData.group_type : ""} 
                                    onChange={(e) => {setGroupData({ ...groupData, group_type: e.target.value });
                                        setSelectManager(null);
                                        setErrors((prevErrors) => ({
                                            ...prevErrors,
                                            group_type: '',
                                        }));
                                    }}>
                                    <option value="">Select</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                    <option value="hybrid">Hybrid</option>
                                </select>
                                {errors.group_type && <p style={{color:"red"}}>{errors.group_type}</p>}
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="flex-end" className=" gap-md-5 gap-2 mt-4">
                                {errorsmessage && <p style={{ color: 'red',width:"100%" }}>{errorsmessage}</p>}
                                {UserRoles === "admin" ? <>
                                {systemGroup !== 1 &&
                                    <button className='cancel_btnbonly' onClick={() => handleShow()}>
                                        Delete
                                    </button>
                                }</> :""}
                                <button className='cancel_btnbonly' onClick={()=>navigate('/user/group')}>Cancel</button>
                                <button className='save_btnbonly' onClick={handleUpdate}>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                            </Grid>
                        </Grid>
                        <Grid size={{sm:11,xs:12}} container justifyContent="flex-start" className="statusselectbtn my-4">
                            <div className='admintab_btnredirect'>
                                <button className={activeTab === "member" ? "active_tabbtn" : ""} onClick={() =>{setActiveTab("member")}}>Members</button>
                                <button className={activeTab === "permissions" ? "active_tabbtn" : ""} onClick={() =>{setActiveTab("permissions")}} >Permissions</button>
                                <button className={activeTab === "kbaccess" ? "active_tabbtn" : ""} onClick={() =>{setActiveTab("kbaccess")}} >KB Access</button>
                            </div>
                        </Grid>
                        {activeTab === "member" ?
                        <Grid size={{xs:12}} container className="tab_membersets mt-0" style={{background:"transparent",boxShadow:"none"}}  justifyContent="center" alignContent="flex-start">
                            {id && !["3", "4", "5"].includes(String(id)) &&
                            <Grid size={{sm:11,xs:12}} container justifyContent="space-between">
                                {groupData.group_type !== "" && 
                                <Grid size={{sm: 5, xs: 12}} container alignItems="flex-start" alignContent="flex-start">
                                    <Grid size={{ xs: 12 }} container flexDirection="column" className="mb-4">
                                        <span>Member Type</span>
                                        <Select
                                            isMulti
                                            name="roles"
                                            value={selectUsersTypes}
                                            onChange={handleUsersTypeChange}
                                            options={rolesTypeUsers}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Choose..."
                                        />
                                        {/* {errors.roles && <p style={{ color: "red" }}>{errors.roles}</p>} */}
                                    </Grid>
                                    <Grid size={{ xs: 12 }} container flexDirection="column" className="mb-5">
                                        <span>Group Manager</span>
                                        {groupData.group_type === "external" ? 
                                        <AsyncPaginate
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            loadOptions={loadOptions}
                                            value={selectManager}
                                            additional={{
                                                page: 1,
                                            }}
                                            debounceTimeout={300}
                                            onChange={handleManagerChange}
                                            isClearable
                                            cacheUniqs={[]}
                                            reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}
                                        />:
                                        <AsyncPaginate
                                            key={cacheKey}
                                            className="basic-single select_withsearch"
                                            classNamePrefix="select"
                                            loadOptions={loadOptionsUpend}
                                            value={selectManager}
                                            additional={{
                                                page: 1,
                                            }}
                                            debounceTimeout={300}
                                            onChange={handleManagerChange}
                                            isClearable
                                            cacheUniqs={[cacheKey]}
                                            reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}
                                        />}
                                        {errors.group_manager_id && <p style={{ color: "red" }}>{errors.group_manager_id}</p>}
                                    </Grid>
                                </Grid>}
                                {selectUsersTypes.length !== 0 && 
                                <Grid size={{ sm: 5, xs: 12 }} container flexDirection="column" className="mb-4">
                                    <span>Users to be added</span>
                                    <Select
                                        isMulti
                                        name="roles"
                                        value={selectUsers}
                                        onChange={handleUsersChange}
                                        options={rolesUsers}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Choose..."
                                    />
                                </Grid>
                                }
                            </Grid>}
                            <Grid size={{sm:11,xs:12}} container className="mt-2" style={{height:"fit-content"}}>
                                <Grid size={{xs:12}} container alignItems="center" justifyContent="flex-end">
                                    <Grid size={{ xl:4, sm:6 ,xs: 12 }} container flexDirection="column">
                                        <div className='d-flex jobseekersearch my-3'>
                                            <div className='col-md-9 input_jobssearch'>
                                                <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                                                <input type='text' placeholder='search'
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        handleSearch(); // Trigger search on Enter key press
                                                    }
                                                }}/>
                                            </div>
                                            <div className='col-md-3 col-4'>
                                                <button onClick={handleSearch}>Search</button>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                                {loading === true ?
                                    <div className='d-flex justify-content-center w-100'>
                                        <img style={{ width: "100px", height: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                                    </div> : <>
                                    <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                                        <DataGrid
                                            style={{minHeight:"200px"}}
                                            rows={rows}
                                            columns={columns}
                                            disableSelectionOnClick
                                            components={{ Toolbar: GridToolbar }}
                                        />
                                    </Box>
                                    <Grid size={{xs:12}} container justifyContent="space-between" className="mt-3">
                                        <div className='d-flex justify-content-end align-items-center'>
                                            <label className='me-2'>Showing records <b>{paginatedata.from}</b>-<b>{paginatedata.to}</b> out of <b>{paginatedata.total}</b></label>
                                        </div>
                                        <div className='d-flex justify-content-end datatable_jobpagi align-items-center'>
                                            <label className='me-2'>No. of Rows</label>
                                            <select
                                                label="Rows per page"
                                                value={selectedRecord || 20}
                                                onChange={(e) => {
                                                    const value = Number(e.target.value);
                                                    setShowRecord(value);
                                                    setCurrentPage(1);
                                                }}
                                                sx={{ mr: 2 }}
                                            >
                                                {[5, 10, 20, 50].map((size) => (
                                                    <option key={size} value={size}>{size}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </Grid>
                                    <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                        <button className='arrowpaginate'
                                            onClick={() => handlePageChange(currentPage - 1)} 
                                            disabled={currentPage === 1}>
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </button>
                                        {paginatedata && paginatedata.last_page > 0 && (
                                            <div className="pagination">
                                                {(() => {
                                                const totalPages = Math.max(1, paginatedata.last_page);
                                                const pages = [];
                    
                                                const start = Math.max(2, currentPage - 2);
                                                const end = Math.min(totalPages - 1, currentPage + 2);
                    
                                                // Always show page 1
                                                pages.push(
                                                    <button
                                                    key={1}
                                                    onClick={() => handlePageChange(1)}
                                                    className={currentPage === 1 ? 'active' : ''}
                                                    >
                                                    1
                                                    </button>
                                                );
                    
                                                // Ellipsis after page 1 if needed
                                                if (start > 2) {
                                                    pages.push(<span key="start-ellipsis">...</span>);
                                                }
                    
                                                // Middle pages
                                                for (let i = start; i <= end; i++) {
                                                    pages.push(
                                                    <button
                                                        key={i}
                                                        onClick={() => handlePageChange(i)}
                                                        className={currentPage === i ? 'active' : ''}
                                                    >
                                                        {i}
                                                    </button>
                                                    );
                                                }
                    
                                                // Ellipsis before last page if needed
                                                if (end < totalPages - 1) {
                                                    pages.push(<span key="end-ellipsis">...</span>);
                                                }
                    
                                                // Always show last page (if more than 1)
                                                if (totalPages > 1) {
                                                    pages.push(
                                                    <button
                                                        key={totalPages}
                                                        onClick={() => handlePageChange(totalPages)}
                                                        className={currentPage === totalPages ? 'active' : ''}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                    );
                                                }
                    
                                                return pages;
                                                })()}
                                            </div>
                                        )}
                                        <button className='arrowpaginate'
                                            onClick={() => handlePageChange(currentPage + 1)} 
                                            disabled={currentPage === paginatedata.last_page}>
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </button>
                                    </Grid>
                                </>}
                            </Grid>
                        </Grid>
                        : activeTab === "permissions" ?
                        <Grid size={{xs:12}} container className="tab_membersets mt-0" style={{background:"transparent",boxShadow:"none"}} justifyContent="center" alignContent="flex-start">
                            {loading === true ?
                            <div className='d-flex justify-content-center w-100'>
                                <img style={{ width: "100px", height: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                            </div> : <>
                            <Grid size={{sm:11,xs:12}} container justifyContent="space-between">
                                <Grid size={{ sm: 5, xs: 12 }} container flexDirection="column" className="mb-3">
                                    <span>Permission Type</span>
                                    <Select
                                        // isMulti
                                        name="roles"
                                        value={selectPermissionTypes}
                                        onChange={handlePermissionType}
                                        options={tabsOption}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Choose..."
                                    />
                                    {/* {errors.roles && <p style={{ color: "red" }}>{errors.roles}</p>} */}
                                </Grid>
                                {selectPermissionTypes.length !== 0 && 
                                    <Grid size={{ sm: 5, xs: 12 }} container flexDirection="column" className="mb-3">
                                        <span>Permission</span>
                                        <Select
                                            isMulti
                                            name="roles"
                                            value={selectPermission}
                                            onChange={handlePermissionChange}
                                            options={permissionOption}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Choose..."
                                        />
                                    </Grid>
                                }

                                <Grid size={{xs:12}} container className="mt-3 pb-3" style={{height:"fit-content"}}>
                                    <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                                        <DataGrid
                                            style={{minHeight:"200px"}}
                                            rows={rows2}
                                            columns={columns2}
                                            disableSelectionOnClick
                                            components={{ Toolbar: GridToolbar }}
                                        />
                                    </Box>

                                    <Grid size={{xs:12}} container justifyContent="space-between" className="mt-3">
                                        <div className='d-flex justify-content-end align-items-center'>
                                            <label className='me-2'>Showing records <b>{paginatedata2.from}</b>-<b>{paginatedata2.to}</b> out of <b>{paginatedata2.total}</b></label>
                                        </div>
                                        <div className='d-flex justify-content-end datatable_jobpagi align-items-center'>
                                            <label className='me-2'>No. of Rows</label>
                                            <select
                                                label="Rows per page"
                                                value={selectedRecord2 || 20}
                                                onChange={(e) => {
                                                    const value = Number(e.target.value);
                                                    setShowRecord2(value);
                                                    setCurrentPage2(1);
                                                }}
                                                sx={{ mr: 2 }}
                                            >
                                                {[5, 10, 20, 50].map((size) => (
                                                    <option key={size} value={size}>{size}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </Grid>
                                    <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                        <button className='arrowpaginate'
                                            onClick={() => handlePageChange2(currentPage2 - 1)} 
                                            disabled={currentPage2 === 1}>
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </button>
                                        {paginatedata2 && paginatedata2.last_page > 0 && (
                                            <div className="pagination">
                                                {(() => {
                                                const totalPages = Math.max(1, paginatedata2.last_page);
                                                const pages = [];
                    
                                                const start = Math.max(2, currentPage2 - 2);
                                                const end = Math.min(totalPages - 1, currentPage2 + 2);
                    
                                                // Always show page 1
                                                pages.push(
                                                    <button
                                                    key={1}
                                                    onClick={() => handlePageChange2(1)}
                                                    className={currentPage2 === 1 ? 'active' : ''}
                                                    >
                                                    1
                                                    </button>
                                                );
                    
                                                // Ellipsis after page 1 if needed
                                                if (start > 2) {
                                                    pages.push(<span key="start-ellipsis">...</span>);
                                                }
                    
                                                // Middle pages
                                                for (let i = start; i <= end; i++) {
                                                    pages.push(
                                                    <button
                                                        key={i}
                                                        onClick={() => handlePageChange2(i)}
                                                        className={currentPage2 === i ? 'active' : ''}
                                                    >
                                                        {i}
                                                    </button>
                                                    );
                                                }
                    
                                                // Ellipsis before last page if needed
                                                if (end < totalPages - 1) {
                                                    pages.push(<span key="end-ellipsis">...</span>);
                                                }
                    
                                                // Always show last page (if more than 1)
                                                if (totalPages > 1) {
                                                    pages.push(
                                                    <button
                                                        key={totalPages}
                                                        onClick={() => handlePageChange2(totalPages)}
                                                        className={currentPage2 === totalPages ? 'active' : ''}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                    );
                                                }
                    
                                                return pages;
                                                })()}
                                            </div>
                                        )}
                                        <button className='arrowpaginate'
                                            onClick={() => handlePageChange2(currentPage2 + 1)} 
                                            disabled={currentPage2 === paginatedata2.last_page}>
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </button>
                                    </Grid>
                                </Grid>
                            </Grid></>}
                        </Grid>:
                        <Grid size={{xs:12}} container className="tab_membersets mt-0" style={{background:"transparent",boxShadow:"none"}} justifyContent="center" alignContent="flex-start">
                            <Grid size={{sm:11,xs:12}} container justifyContent="space-between">
                                <KbAcessGroup/>
                            </Grid>
                        </Grid>
                        }
                    </>}
                </Grid>
                <Grid size={{sm:11}} container className="ps-md-5 gap-md-5 gap-2 mb-4">
                    {errorsmessage && <p style={{ color: 'red',width:"100%" }}>{errorsmessage}</p>}
                    {UserRoles === "admin" ? <>
                    {systemGroup !== 1 &&
                        <button className='cancel_btnbonly' onClick={() => handleShow()}>
                            Delete
                        </button>
                    }</> :""}
                    <button className='cancel_btnbonly' onClick={()=>navigate('/user/group')}>Cancel</button>
                    <button className='save_btnbonly' onClick={handleUpdate}>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                </Grid>
            </Grid>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Group Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this Group?</Modal.Body>
                <Modal.Footer>
                    <button className='modal_cancel' onClick={handleClose}>
                        Cancel
                    </button>
                    <button className='modal_delete' onClick={handleDelete}>
                        Delete
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  )
}

export default UserGroupEdit
